import { assign } from "xstate";
import type { ActionWithMetadata } from "./save-form-data.action";

/**
 * Update Pending Prices Mode Action
 */
export const updatePendingPricesMode: ActionWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState action params are complex
  impl: assign(({ event }: any) => {
    return {
      pendingPricesMode: event.data?.pendingPricesMode ?? false,
    };
  }),
  metadata: {
    displayName: "updatePendingPricesMode",
    description: "Update pendingPricesMode in context",
    category: "context",
  },
};
